import { createContext, ReactElement, ReactNode, useContext, useMemo } from 'react'

import { useQueryParams } from '../../../../../hooks/useQueryParams'
import { InvoiceEditorQueryParams } from '../types/invoiceEditorQueryParams'

interface ContextState {
  queryParams?: InvoiceEditorQueryParams
  setQueryParams: (
    params:
      | Partial<InvoiceEditorQueryParams>
      | ((prevParams: Partial<InvoiceEditorQueryParams>) => Partial<InvoiceEditorQueryParams>),
  ) => void
}

const InvoiceEditorQueryParamsContext = createContext<ContextState | undefined>(undefined)

interface InvoiceEditorQueryParamsProviderProps {
  children?: ReactNode
}

export const InvoiceEditorQueryParamsProvider = ({ children }: InvoiceEditorQueryParamsProviderProps): ReactElement => {
  const [queryParams, setQueryParams] = useQueryParams<InvoiceEditorQueryParams>({
    defaultQuery: {
      depositAmount: undefined,
      depositType: undefined,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      contact_id: undefined,
    },
  })

  const contextValue = useMemo(() => ({ queryParams, setQueryParams }), [queryParams, setQueryParams])

  return (
    <InvoiceEditorQueryParamsContext.Provider value={contextValue}>{children}</InvoiceEditorQueryParamsContext.Provider>
  )
}

export const useInvoiceEditorQueryParams = () => {
  const context = useContext(InvoiceEditorQueryParamsContext)

  if (!context) {
    throw new Error('InvoiceEditorQueryParamsContextProvider is missing in the module!')
  }

  return context
}
